import PropTypes from 'prop-types';
import {useTheme} from 'react-jss';
import {connect} from 'react-redux';
import isUsingArtemisStyles from '../../../v2/selectors/isUsingArtemisStyles';
import useStyles from './LoginNewAccount.styles';
import Button from '../../../UI/Button/Button';
import {createAccount} from '../../../v2/actions/createAccountActions';
import {redirect} from '../../../v2/api/redirect';
import Translation from '../../../v2/lang/Translation';
import {getSettings, getSiteDataV2, isNewGuestUpdatedPage} from '../../../v2/selectors/selectors';
import SocialSharing from '../SocialSharing/SocialSharing';

import AccountBenefits from './CreateAccountForm/AccountBenefits';

export function LoginNewAccount(props) {
  const theme = useTheme();
  const classes = useStyles({...props, theme});
  
  return (
    <div className={classes.loginNewAccount} data-test="LoginNewAccount">
  
      <AccountBenefits />
      
      <div className={classes.innerContainer}>
        <div className={classes.successMessage} data-test="LoginNewAccount__successMessage">
          <Translation>thanks.for.account.creation</Translation>
        </div>
        <div className={classes.accountLogin} data-test="LoginNewAccount__accountLogin">
          <Translation>login.to.view.order</Translation>
        </div>
        <Button
          id="LoginNewAccount__loginButton"
          className={classes.loginButton}
          data-test="LoginNewAccount__loginButton"
          primary
          fullWidth
          onClick={() => redirect.doRedirect(props.loginPageURL)}
        >
          <Translation>login.button</Translation>
        </Button>
      </div>
      
      {props.showSocialSharing
      && (
        <div className={classes.socialSharingContainer} data-test="LoginNewAccount__socialSharingContainer">
          <SocialSharing />
        </div>
      )}
    </div>
  );
}

LoginNewAccount.propTypes = {
  loginPageURL: PropTypes.string.isRequired,
  showSocialSharing: PropTypes.bool,
  isUsingArtemisStyles: PropTypes.bool,
  isNewGuestUpdatedPage: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
  loginPageURL: getSettings(state).login_url || `${getSiteDataV2(state).unsecureHomePageUrl}login.jsp`,
  showSocialSharing: !!getSettings(state).enable_guest_referrals_social_sharing,
  isNewGuestUpdatedPage: isNewGuestUpdatedPage(state),
  isUsingArtemisStyles: isUsingArtemisStyles(state),
});

export default connect(
  mapStateToProps, {
    createAccount,
  },
)(LoginNewAccount);
